import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["skillsContainer", "skillInput", "skillTemplate"];

  static values = {
    reparseUrl: String,
  };

  declare reparseUrlValue: string;
  declare readonly skillsContainerTarget: HTMLElement;
  declare readonly skillInputTarget: HTMLInputElement;
  declare readonly skillTemplateTarget: HTMLTemplateElement;

  close(event: Event) {
    event.preventDefault();
    this.element.remove();
  }

  addSkill(event: KeyboardEvent | FocusEvent) {
    if (event.type === "keydown" && (event as KeyboardEvent).key !== "Enter") {
      return;
    }

    if (event.type === "keydown") {
      event.preventDefault();
    }

    const value = this.skillInputTarget.value.trim();
    if (value === "") return;

    const content = this.skillTemplateTarget.innerHTML.replace(
      /TEMPLATE_VALUE/g,
      value
    );

    this.skillsContainerTarget.insertAdjacentHTML("beforeend", content);

    this.skillInputTarget.value = "";
  }

  removeSkill(event: Event) {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.closest(".tag-wrapper")?.remove();
  }
  // --------------------------------

  async reparse(event: Event) {
    event.preventDefault();

    if (
      !window.confirm(
        "Are you sure you want to re-run AI parsing? This will discard all your current edits and reset the CV."
      )
    ) {
      return;
    }
    // ------------------------------------------------------------

    const button = event.currentTarget as HTMLButtonElement;

    button.classList.add("hidden");

    const container = document.getElementById("cv-form-container");
    if (container) {
      container.innerHTML = `
        <div class="flex flex-col items-center justify-center h-full space-y-4">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
          <p class="text-gray-500">Restarting AI Engine...</p>
        </div>
       `;
    }

    try {
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

      const response = await fetch(this.reparseUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken || "" },
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      if (data.status === "success" && data.html) {
        this.element.outerHTML = data.html;
      }
    } catch (error) {
      console.error("Reparse error:", error);
      alert("Failed to re-process CV. Please try again.");
      button.classList.remove("hidden"); // Hiện lại nút nếu lỗi mạng
    }
  }

  save(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    if (button.disabled) {
      event.preventDefault();
      return;
    }

    button.style.width = `${button.offsetWidth}px`;
    button.innerHTML = `<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-current inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Processing...`;
    button.classList.add("opacity-75", "cursor-wait");

    event.preventDefault();
    const formId = button.getAttribute("form");
    const form = document.getElementById(formId!) as HTMLFormElement;

    if (form) {
      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "commit";
      hiddenInput.value = button.value;
      form.appendChild(hiddenInput);
      button.disabled = true;
      form.requestSubmit();
    }
  }
}
